// client/src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import PortfolioLayout from './components/layout/PortfolioLayout';
import Home from './pages/Home';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import Companies from './pages/Companies';
import Press from './pages/Press';
import Unsubscribe from './pages/Unsubscribe';
import LegalDocument from './components/LegalDocument';
import ScrollToTop from "./components/ScrollToTop";



const NotFound = () => (
    <div className="max-w-4xl mx-auto py-16 px-4 text-center">
        <h1 className="text-3xl font-bold mb-4">404 - Page Not Found</h1>
        <p className="text-gray-600 mb-8">The page you're looking for doesn't exist.</p>
        <a href="/" className="text-orange-600 hover:text-orange-800">Go back home</a>
    </div>
);

function App() {
    return (
        <HelmetProvider>
            <Router>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<PortfolioLayout />}>
                        <Route index element={<Home />} />
                        <Route path="about" element={<About />} />
                        <Route path="portfolio" element={<Portfolio />} />
                        <Route path="companies" element={<Companies />} />
                        <Route path="press" element={<Press />} />
                        <Route path="contact" element={<Contact />} />
                        <Route
                            path="privacy"
                            element={
                                <LegalDocument
                                    documentType="privacy"
                                    title="Privacy Policy"
                                    description="How we collect, use, and protect your personal information"
                                />
                            }
                        />
                        <Route
                            path="terms"
                            element={
                                <LegalDocument
                                    documentType="terms"
                                    title="Terms of Service"
                                    description="Terms and conditions for using our website and services"
                                />
                            }
                        />
                        <Route path="unsubscribe" element={<Unsubscribe />} />
                        <Route path="*" element={<NotFound />} />

                    </Route>
                </Routes>
            </Router>
        </HelmetProvider>
    );
}

export default App;